module.exports = __webpack_public_path__ + "img/img3.06e8c3aa.png";